module.exports = __webpack_public_path__ + "static/media/skull-cow.e7766873.svg";